import {getUserList} from '@/api/user.js'
import {updateContract} from '@/api/contract.js'
import {getSearchParm} from "@/utils/index.js"
import {message} from 'ant-design-vue'


let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)

const columns =[
	{dataIndex:"username",title:"姓名"},
	{dataIndex:"phonenum",title:"电话"},
	{dataIndex:"idcard",title:"身份证号"},
]

export default {
	data(){
		return {
			visible:false,
			columns,
			dataSource:[],
			selectedRowKeys:[],
			id:"",
			pagination:{
				pageSize:10,
				total:0,
				current:1
			},
			callback:"",
			isallsee:false,
			searchdata:getSearchParm({
				username:"",
				phonenum:"",
				idcard:""
			})
		}
	},
	props:[
	],
	methods:{
		saveauth(){
			this.visible = false
			let auth = JSON.stringify(this.selectedRowKeys)
			if(this.isallsee){
				auth = JSON.stringify([-1])
			}
			let hide =  message.loading("正在处理",200)
			updateContract({
				id:this.id,auth
			}).then(ret=>{
				hide()
				if(ret.code == 0){
					this.callback()
					message.success("成功",1)
				}else{
					message.error("失败",1)
				}
			})
		},
		allsee(e){
			let {target:{checked}} = e
			this.isallsee = checked
		},
		showAuth(record,callback){
			let {id,auth} = record
			this.callback = callback
			if(auth == null||auth=="null"||auth=="[-1]"){
				this.selectedRowKeys =[]
				if(auth == "[-1]"){
					this.isallsee = true
				}
			}else{
				this.selectedRowKeys = JSON.parse(auth)
			}
			this.id = id
			this.visible = true
		},
		getuser(parm){
			parm = {...parm,cmpid:user.cmpid}
			getUserList(parm).then(ret=>{
				if(ret.code === 0){
					let {data:{rows,count}} = ret
					this.dataSource = rows
					this.pagination = {...this.pagination,total:count}
				}
			})
		},
		pagechange(page){
			let {current,pageSize} = page
			this.pagination = {...this.pagination,current,pageSize}
			this.getuser({current,pageSize})
		},
		onSelectChange(slts){
			console.log(slts,"aaa")
			this.selectedRowKeys = slts
		},
		find(){
			let {current,pageSize} = this.pagination
			this.getuser({current,pageSize,...this.searchdata})
		}
	},
	mounted(){
		this.getuser({current:1,pageSize:10})
	}
}